import { useState } from 'react';
import { useQuery } from '@tanstack/react-query';
import { Link } from 'react-router-dom';
import { apiClient } from '../../api/client';
import { Search, BookOpen } from 'lucide-react';
import PageHeader from '../../components/PageHeader';
import EmptyState from '../../components/EmptyState';

export default function PortalKnowledgeBase() {
  const [search, setSearch] = useState('');

  const { data, isLoading } = useQuery({
    queryKey: ['portal-kb', search],
    queryFn: async () => {
      const params = new URLSearchParams({ status: 'published', visibility: 'external' });
      if (search) params.set('search', search);
      const res = await apiClient.get(`/kb?${params}`);
      return res.data.data?.articles ?? res.data.data ?? [];
    },
  });

  const articles = data ?? [];

  return (
    <div className="flex flex-col gap-4 pb-10">
      <PageHeader
        title="Knowledge Base"
        intro="Find answers in our help articles. Search by keyword to narrow the list."
      />

      <div className="card">
        <div className="relative">
          <Search className="absolute left-3 top-1/2 -translate-y-1/2 w-4 h-4 text-muted" />
          <input
            type="search"
            placeholder="Search articles..."
            value={search}
            onChange={(e) => setSearch(e.target.value)}
            className="input pl-9"
          />
        </div>
      </div>

      <div className="card" style={{ padding: 0 }}>
        {isLoading ? (
          <div className="py-12 text-center text-muted">Loading articles...</div>
        ) : articles.length === 0 ? (
          <EmptyState icon={<BookOpen className="w-10 h-10" />}>
            No articles found. Try a different search.
          </EmptyState>
        ) : (
          <div>
            {articles.map((article: any) => (
              <Link
                key={article.id ?? article._id}
                to={`/portal/kb/${article.slug}`}
                className="flex items-start gap-4 px-6 py-4 hover:bg-row-odd transition-colors border-b border-line-light last:border-0"
              >
                <BookOpen className="w-5 h-5 text-primary flex-shrink-0 mt-0.5" />
                <div className="flex-1 min-w-0">
                  <p className="text-sm font-medium text-fg">
                    {article.title}
                  </p>
                  {article.excerpt && (
                    <p className="text-xs text-muted mt-1 line-clamp-2">
                      {article.excerpt}
                    </p>
                  )}
                  <div className="flex items-center gap-3 mt-1">
                    {article.category && (
                      <span className="text-xs text-primary">{article.category}</span>
                    )}
                    <span className="text-xs text-muted">
                      {new Date(article.createdAt).toLocaleDateString()}
                    </span>
                  </div>
                </div>
              </Link>
            ))}
          </div>
        )}
      </div>
    </div>
  );
}
